import React from 'react';
import styled from 'styled-components';
import {
  BoldHeader4Text,
  Button,
  FlexRow,
  Grid,
  Icon,
  IconSize,
  IconType,
  ISpruceFieldProps,
  TextInput,
  GridItem,
  PhoneNumberInput,
  SpruceField,
} from 'ui-toolkit';
import { EditAddressDataEntry } from '../../../ui-toolkit/orders/components/EditPropertyAddress/EditAddressDataEntry';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';

interface ISignatoryFormProps {
  indexOfParty: number;
  indexOfSignatory: number;
  onClickDelete: () => void;
  autoFocus: boolean;
}

const Header = styled(BoldHeader4Text)`
  white-space: nowrap;
`;
const HorizontalRule = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.gray};
  width: 100%;
`;

export const SignatoryForm: React.FC<ISignatoryFormProps> = ({
  indexOfParty,
  indexOfSignatory,
  onClickDelete,
  autoFocus,
}) => {
  const fieldNameStart = `parties.${indexOfParty}.signatories.${indexOfSignatory}`;
  return (
    <>
      <FlexRow>
        <Header>Signatory {indexOfSignatory + 1}</Header>
        <HorizontalRule />
        <Button
          intent="ghost"
          isInline
          onClick={onClickDelete}
          data-test-id={mergeTests(`party`, `${indexOfParty}`, `signatories`, `${indexOfSignatory}`, `delete`)}
        >
          <Icon type={IconType.Remove} size={IconSize.Small} />
        </Button>
      </FlexRow>
      <Grid columnCount={6}>
        <GridItem columnStart={'span 2'}>
          <SpruceField name={`${fieldNameStart}.firstName`}>
            {({ field }: ISpruceFieldProps) => (
              <TextInput
                {...field}
                data-test-id={`${fieldNameStart}.first_name`}
                label={`First Name`}
                isRequired={true}
                placeholder={'Johnny'}
                autoFocus={autoFocus}
              />
            )}
          </SpruceField>
        </GridItem>
        <GridItem columnStart={'span 2'}>
          <SpruceField name={`${fieldNameStart}.middleName`}>
            {({ field }: ISpruceFieldProps) => (
              <TextInput
                {...field}
                data-test-id={`${fieldNameStart}.middle_name`}
                label={`Middle Name`}
                isRequired={false}
                placeholder={'"L" or "Leroy"'}
              />
            )}
          </SpruceField>
        </GridItem>
        <GridItem columnStart={'span 2'}>
          <SpruceField name={`${fieldNameStart}.lastName`}>
            {({ field }: ISpruceFieldProps) => (
              <TextInput
                {...field}
                data-test-id={`${fieldNameStart}.last_name`}
                label={`Last Name`}
                isRequired={true}
                placeholder={'Appleseed'}
              />
            )}
          </SpruceField>
        </GridItem>
        <GridItem columnStart={'span 3'}>
          <SpruceField name={`${fieldNameStart}.email`}>
            {({ field }: ISpruceFieldProps) => (
              <TextInput
                {...field}
                data-test-id={field.name}
                label={`Email`}
                isRequired={false}
                placeholder={'johnny@appleseed.com'}
              />
            )}
          </SpruceField>
        </GridItem>
        <GridItem columnStart={'span 3'}>
          <SpruceField name={`${fieldNameStart}.phoneNumber`}>
            {({ field }: ISpruceFieldProps) => (
              <PhoneNumberInput
                {...field}
                data-test-id={`${fieldNameStart}.phone_number`}
                label={`Phone Number`}
                isRequired={false}
              />
            )}
          </SpruceField>
        </GridItem>
        <Header>Current Address</Header>
        <GridItem columnStart={'span 12'}>
          <EditAddressDataEntry name={`${fieldNameStart}.address`} isCamelCase />
        </GridItem>
      </Grid>
    </>
  );
};
